<script type="text/jsx">
import buyTrial from './buy-trial';
import addTrial from './add-trial';
import BuyNow from './buy-now';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};

    if (this.$context.is.buyTrial) return <buyTrial {...context} />;
    if (this.$context.is.add2trial) return <addTrial {...context} />;
    return <BuyNow {...context} />;
  },
};
</script>